module.exports = __webpack_public_path__ + "static/media/ic-chevron-down.2056dcd2.svg";